import { useContext } from "react"
import { GlobalContext } from "../Context/globalContext"
import { Footer } from "./footer";
import { Header } from "./header";
import { Sidebar } from "./sidebar";

export const Layout = (props) => {

    const globalContext = useContext(GlobalContext);

    return (
        <>
            {globalContext.loggedIn ?
                <>
                    <Header />
                    {/* <Sidebar /> */}
                    {props.children}
                    <Footer />
                </>
                :
                <>
                    {props.children}
                </>
            }
        </>
    )

}